import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import 'vuetify/src/stylus/app.styl';
import colors from 'vuetify/es5/util/colors';

const theme = {
  dark: true,
  themes: {
    dark: {
      primary: colors.red.base,
      secondary: colors.teal.base,
      accent: colors.green.base,
      error: colors.deepOrange.base,
      warning: colors.orange.base,
      info: colors.yellow.base,
      success: colors.lightGreen.base,
    },
  },
};

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme,
});
